var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_303_721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3259 41.0872C46.3629 40.8674 46.3822 40.6412 46.3822 40.4103C46.3822 38.2507 44.6922 36.5 42.6074 36.5C41.0576 36.5 39.7259 37.4676 39.1446 38.8514C38.6736 38.4302 38.0625 38.1759 37.3946 38.1759C35.9055 38.1759 34.6983 39.4403 34.6983 41C34.6983 41.0869 34.7021 41.1728 34.7094 41.2576C33.9932 41.6211 33.5 42.3836 33.5 43.2655C33.5 44.4996 34.4657 45.5 35.657 45.5H45.843C47.0343 45.5 48 44.4996 48 43.2655C48 42.2034 47.2847 41.3144 46.3259 41.0872Z",
    fill: "url(#paint0_linear_303_721)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_303_721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3799 65.3781C81.5485 64.4253 81.6364 63.4452 81.6364 62.4448C81.6364 53.0865 73.9438 45.5 64.4545 45.5C57.4001 45.5 51.3386 49.6928 48.6925 55.6894C46.5488 53.8641 43.7671 52.7621 40.7273 52.7621C33.9492 52.7621 28.4545 58.2412 28.4545 65C28.4545 65.3764 28.4716 65.7488 28.5049 66.1165C25.2448 67.6913 23 70.9957 23 74.8172C23 80.1649 27.3957 84.5 32.8182 84.5H79.1818C84.6043 84.5 89 80.1649 89 74.8172C89 70.2148 85.7441 66.3624 81.3799 65.3781Z",
    fill: "url(#paint1_linear_303_721)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5909 40.5138C91.5909 41.1935 91.5323 41.8595 91.4199 42.5069C94.3294 43.1757 96.5 45.7934 96.5 48.9207C96.5 52.5543 93.5695 55.5 89.9545 55.5H80.1317C77.4424 49.6047 71.4345 45.5 64.4545 45.5C59.8664 45.5 55.6983 47.2736 52.6166 50.1635C52.5401 49.761 52.5 49.3456 52.5 48.9207C52.5 46.324 53.9965 44.0787 56.17 43.0086C56.1477 42.7588 56.1364 42.5057 56.1364 42.25C56.1364 37.6575 59.7995 33.9345 64.3182 33.9345C66.3447 33.9345 68.1992 34.6833 69.6283 35.9236C71.3924 31.8489 75.4334 29 80.1364 29C86.4625 29 91.5909 34.1549 91.5909 40.5138Z",
    fill: "url(#paint2_linear_303_721)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_303_721",
    x: 33.5,
    y: 36.5,
    width: 14.5,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_721"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_303_721",
    x: 23,
    y: 45.5,
    width: 66,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_721"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_721",
    x: 52.5,
    y: 29,
    width: 44,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_721",
    x1: 34.4223,
    y1: 44.6964,
    x2: 49.5118,
    y2: 33.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_721",
    x1: 27.1979,
    y1: 81.0179,
    x2: 93.5604,
    y2: 31.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_721",
    x1: 93.7014,
    y1: 53.1339,
    x2: 48.8549,
    y2: 20.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyDay);
export default __webpack_public_path__ + "static/media/Cloudy_Day.f36293b3808f40963126949457023b7e.svg";
export { ForwardRef as ReactComponent };